import { DialogActions } from "@material-ui/core";
import React from "react";
import DialogLayout from "../../../../partials/content/DialogLayout";
import { calculateTax } from "../../../../utils/utils";
import SearchTax from "../../setup/finance/searchTax";

function SalesTax({
  openSearchTax,
  setOpenSearchTax,
  propertyAddCost,
  taxLevel,
  values,
  property,
  itemIndex,
  setFieldValue,
  calculateItemTotalPrice,
}) {
  return (
    <DialogLayout
      open={openSearchTax}
      title="Search Tax"
      onCloseDialog={() => {
        setOpenSearchTax(false);
      }}
      maxWIdth="sm"
    >
      <SearchTax
        onSelectTax={(tax) => {
          if (taxLevel === "item") {
            calculateTax(
              tax.taxPercent,
              values,
              property,
              "percent",
              itemIndex,
              setFieldValue,
              propertyAddCost
            );
            calculateItemTotalPrice(
              setFieldValue,
              values[property][itemIndex],
              itemIndex
            );
            setFieldValue(`${property[itemIndex].taxName}`, tax.taxName);
          } else if (taxLevel === "header") {
            calculateTax(
              tax.taxPercent,
              values,
              property,
              "percent",
              -1,
              setFieldValue,
              propertyAddCost
            );
          }
          setOpenSearchTax(false);
        }}
      />
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={() => {
            setOpenSearchTax(false);
          }}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
      </DialogActions>
    </DialogLayout>
  );
}

export default SalesTax;
